import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { updateLoginTimestamp } from "../../redux/loginSlice";

const API = "https://crmapi.kozeglobal.com/api";
const FILTER = `${API}/get_all_wallet_history_filter.php`;

const WalletHistory = ({ data = [] }) => {
  const token = localStorage.getItem("userToken");
  const [fdate, setFdate] = useState("");
  const [edate, setEdate] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const dispatch = useDispatch();

  useEffect(() => {
    const updateTimestamp = () => {
      const currentTime = new Date().getTime();
      localStorage.setItem("loginTimestamp", currentTime.toString());
      dispatch(updateLoginTimestamp());
    };

    updateTimestamp();
  }, [dispatch]);

  const today = new Date().toISOString().split("T")[0];

  const isSubmitButtonDisabled = !fdate || !edate;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitButtonDisabled) return;

    if (new Date(fdate) > new Date(edate)) {
      setValidationError("The 'From' date cannot be later than the 'To' date.");
      return;
    }

    setLoading(true);
    setError(null);
    setValidationError(null);

    const requestData = {
      token,
      fdate,
      edate,
    };

    try {
      const response = await axios.post(FILTER, requestData);
      console.log("API Response Data:", response.data);
      const responseData = Array.isArray(response.data.data.response)
        ? response.data.data.response
        : [];
      setFilteredData(responseData);
      setIsFiltered(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("An error occurred while fetching the data.");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFilteredData(Array.isArray(data) ? data : []);
    setIsFiltered(false);
    setFdate("");
    setEdate("");
    setValidationError(null);
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
  };

  const formatAmount = (amount) => {
    return amount ? parseFloat(amount).toFixed(2) : "-";
  };

  return (
    <>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body mt-4">
              <div className="d-flex gap-1 justify-content-center align-items-center flex-wrap flex-md-nowrap">
                <div className="form-group">
                  <label htmlFor="from">From</label>
                  <input
                    type="date"
                    className="form-control"
                    id="from"
                    value={fdate}
                    onChange={(e) => setFdate(e.target.value)}
                    max={today}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="to">To</label>
                  <input
                    type="date"
                    className="form-control"
                    id="to"
                    value={edate}
                    onChange={(e) => setEdate(e.target.value)}
                    max={today}
                  />
                </div>

                <button
                  className="btn text-black border rounded mt-2"
                  onClick={handleSubmit}
                  disabled={isSubmitButtonDisabled}
                >
                  Submit
                </button>
                {isFiltered && (
                  <button
                    className="btn text-black border rounded mt-2 ms-2"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                )}
              </div>
              {loading && <p>Loading...</p>}
              {error && <p className="text-danger">{error}</p>}
              {validationError && (
                <p className="text-danger">{validationError}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="card-body mt-4">
        <p className="mb-4">
          <strong>Withdrawal:</strong> 84.47
        </p>
        <div className="table-responsive">
          {filteredData.length > 0 ? (
            <Table striped responsive className="custom-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Credit</th>
                  <th>Debit</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{formatDate(item.date)}</td>
                    <td>{formatAmount(item.Balance)}</td>
                    <td>{item.Debit || "-"}</td>
                    <td>{item.Credit || "-"}</td>
                    <td>{item.Details || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Table striped responsive className="custom-table">
              <tbody>
                <tr style={{ height: "100px" }}>
                  <td colSpan="8" className="text-center">
                    No data available
                  </td>
                </tr>
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};

export default WalletHistory;
